export const API='/api';
export async function api(path,options={}){
  const response=await fetch(API+path,{credentials:'include',...options,headers:{...(options.body && !(options.body instanceof FormData)?{'Content-Type':'application/json'}:{}),...options.headers}});
  const contentType=response.headers.get('content-type')||'';
  let data={};
  if(contentType.includes('application/json')){
    data=await response.json().catch(()=>({}));
  } else {
    // Non-JSON response (HTML error page, etc.) - treat as error
    const text=await response.text().catch(()=>'');
    data={detail: text.slice(0,500) || 'Invalid response from server'};
  }
  if(!response.ok){
    const detail=Array.isArray(data.detail)?data.detail.map(e=>e.msg).join('; '):data.detail;
    const error=new Error(detail || 'Something went wrong. Please try again.');
    error.status=response.status;
    throw error;
  }
  return data;
}
export const money=value=>new Intl.NumberFormat('uk-UA',{style:'currency',currency:'UAH',maximumFractionDigits:0}).format(value||0);
export async function downloadExport(format){
  const response=await fetch(`${API}/admin/export/${format}`,{credentials:'include'});
  if(!response.ok)throw new Error('Export failed. Please sign in again.');
  const url=URL.createObjectURL(await response.blob());
  const link=document.createElement('a');link.href=url;link.download=`asans-products.${format}`;link.click();
  setTimeout(()=>URL.revokeObjectURL(url),1000);
}
